/**
 * Meet хранит OAuth JWT (meet-сессия), но не accessToken мессенджера.
 * Workspace REST VCS (`/api/v2/vcs/*` без суффикса OAuth) требуют accessToken в Authorization.
 * В meet всегда используем *OAuth endpoints с conference jwtToken (LiveKit) в теле запроса.
 */
export const shouldUseMeetVcsOAuthApi = (conferenceJwtToken: string | null | undefined): boolean => {
    return Boolean(conferenceJwtToken);
};
